$(document).ready(function () {
  console.log("--- accordion.js loaded ---");

  $(".accordion-header").on("click", function () {
    let target = $(this).attr("data-accordion");
    let content = $(`.accordion-content[data-content='${target}']`);
    let icon = $(this).find(".accordion-icon");
    let header = $(this).find("span");

    if (content.is(":visible")) {
      content.slideUp();
      icon.text("+").css("color", ""); // Reset icon color
      header.css("color", ""); // Reset text color
    } else {
      $(".accordion-content").slideUp();
      $(".accordion-icon").text("+").css("color", ""); // Reset all icons
      $(".accordion-header span").css("color", ""); // Reset all headers

      content.slideDown();
      icon.text("−").css("color", "#77ba20"); // Active icon color
      header.css("color", "#77ba20"); // Active header text color
    }
  });
});
